import React from 'react';
import { Search20Regular, Copy16Regular, Info16Regular, MoreHorizontal20Regular } from '@fluentui/react-icons';
import { Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { toast } from 'react-toastify';
import styles from '../css/vdr.module.css';
import AddNewMenu from './AddNewMenu';

const VDRHeader = ({
    statusCounts = { ready: 0, processing: 0, needsAttention: 0 },
    mailbox = '',
    onSearch,
    onAnalytics,
    onBackToVdr,
    analyticsActive = false,
    onExternalVDR,
    onAddNew,
    searchActive,
    includeRecording = true,
}) => {
    const handleCopyMailbox = async () => {
        try {
            await navigator.clipboard.writeText(mailbox);
            toast.success('Mailbox address copied');
        } catch {
            toast.info(mailbox);
        }
    };

    return (
        <header className={styles.header}>
            <div className={styles.headerLeft}>
                <div className={styles.headerTitleRow}>
                    <h1 className={styles.headerTitle}>VDR</h1>
                    <p style={{ margin: 0 }}>
                        <span className={styles.statusReady}>{statusCounts.ready} ready</span>
                        <span className={styles.statusSep}> · </span>
                        <span className={styles.statusProcessing}>{statusCounts.processing} processing</span>
                        <span className={styles.statusSep}> · </span>
                        <span className={styles.statusAttention}>{statusCounts.needsAttention} needs attention</span>
                    </p>
                </div>
            </div>

            <div className={styles.headerActions}>
                <button type="button" className={`${styles.headerLink} ${searchActive ? styles.headerLinkActive : ''}`} onClick={onSearch}>
                    <Search20Regular />
                    Search VDR
                </button>
                {analyticsActive ? (
                    <button type="button" className={`${styles.headerLink} ${styles.headerLinkActive}`} onClick={onBackToVdr}>
                        VDR
                    </button>
                ) : (
                    <button type="button" className={styles.headerLink} onClick={onAnalytics}>
                        Analytics
                    </button>
                )}
                <button type="button" className={styles.headerLink} onClick={onExternalVDR}>
                    External VDR
                </button>
                <Menu>
                    <MenuTrigger disableButtonEnhancement>
                        <button type="button" className={styles.iconBtn} aria-label="More">
                            <MoreHorizontal20Regular />
                        </button>
                    </MenuTrigger>
                    <MenuPopover>
                        <MenuList>
                            <MenuItem onClick={() => onAddNew?.('classic')}>Open classic dataroom</MenuItem>
                        </MenuList>
                    </MenuPopover>
                </Menu>
                <AddNewMenu onSelect={onAddNew} includeRecording={includeRecording} />
            </div>
        </header>
    );
};

export default VDRHeader;
